import { Card, Text } from '@serodigital/ui-components';
import * as React from 'react';
import { ColourCards } from '../../components/colourCards';
import { Degree } from '../../components/degree';

interface IDetailsStatusProps {
  Title: JSX.Element;
  Status: JSX.Element;
  showTemp?: boolean;
  setpoint?: number;
  temperature?: number;
  SetpointRightColumn?: JSX.Element;
  upperBounds?: number;
  lowerBounds?: number;
  setpointTitle?: string;
}

export function DetailsStatus({
  Status,
  Title,
  setpoint,
  temperature,
  SetpointRightColumn,
  showTemp = false,
  lowerBounds,
  upperBounds,
  setpointTitle,
}: IDetailsStatusProps) {
  return (
    <Card data-qa="status-card" CardTitle={Title}>
      <div className="flex space-x-8 justify-between select-none">
        {Status}
        <div className="flex space-x-16">
          {showTemp && (
            <ColourCards
              disabled={!temperature}
              key="tempt"
              kind={'orange'}
              header={
                <span className="flex">
                  {temperature?.toFixed(1) ?? '--'}
                  <Degree />
                </span>
              }
              label={'Current temp'}
            />
          )}
          <ColourCards
            key="setpoint"
            disabled={!setpoint}
            kind={'blue'}
            header={
              <span className="flex" data-qa="setpoint">
                {setpoint?.toFixed(1) ?? '--'}
                <Degree />
              </span>
            }
            label={setpointTitle}
            RightColumn={SetpointRightColumn}
          />
        </div>
      </div>
      {upperBounds && lowerBounds && (
        <div className="flex justify-end mr-52">
          <Text size="small" className="italic mt-8 flex">
            <Text data-qa="lower-bound" className="flex">
              Min:{' '}
              <Text className="ml-4" weight="bold">
                {lowerBounds}
              </Text>{' '}
              <Degree height={20} width={15} fill="#6A6A69" />
            </Text>
            <Text className="ml-4 mr-4">{' | '}</Text>
            <Text data-qa="upper-bound" className="flex">
              Max:{' '}
              <Text className="ml-4" weight="bold">
                {upperBounds}
              </Text>{' '}
              <Degree height={20} width={15} fill="#6A6A69" />
            </Text>
          </Text>
        </div>
      )}
    </Card>
  );
}
